import { render } from "./UserLogs.vue?vue&type=template&id=678d1610&scoped=true"
import script from "./UserLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./UserLogs.vue?vue&type=script&setup=true&lang=js"

import "./UserLogs.vue?vue&type=style&index=0&id=678d1610&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678d1610"],['__file',"resources/js/modules/coaching_user/components/UserLogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "678d1610"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('678d1610', __exports__)) {
    api.reload('678d1610', __exports__)
  }
  
  module.hot.accept("./UserLogs.vue?vue&type=template&id=678d1610&scoped=true", () => {
    api.rerender('678d1610', render)
  })

}


export default __exports__